module.exports = __webpack_public_path__ + "img/1f915.f99bd05.svg";